export default {
  computed: {
    avatarThumbUrl() {
      return this.sanitizeAvatarUrl(this.$store.getters['user/get']?.avatarThumbUrl);
    },
    avatarMediumUrl() {
      return this.sanitizeAvatarUrl(this.$store.getters['user/get']?.avatarMediumUrl);
    },
    avatarOriginalUrl() {
      return this.sanitizeAvatarUrl(this.$store.getters['user/get']?.avatarOriginalUrl);
    },
  },
  methods: {
    sanitizeAvatarUrl(url) {
      if (typeof url === 'string' && url.endsWith('_missing.png')) {
        return '';
      }
      return url || '';
    },
  },
};
